import { createRouteRef } from '@backstage/frontend-plugin-api';

export const accessRouteRef = createRouteRef();
export const groupsRouteRef = createRouteRef();
export const homeRouteRef = createRouteRef();
export const searchRouteRef = createRouteRef();
export const settingsRouteRef = createRouteRef();
